export const error = state => state.error
export const isLoading = state => state.isLoading
export const items = state => state.items
export const view = state => state.view
export const vatRateOptions = (state) => state.items.map(entry => {
  return {
    text: entry.range,
    value: entry['@id']
  }
})
